import React, { Fragment } from 'react';
import { Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SvgIcon from '../../../Helpers/Svg/SvgIcon';
import "./About.scss";

export default function About({ data, customData }) {
  const { title, description, productSpecifications } = !customData ? data : customData;

  return (
    <Fragment>
      <Row className="about-wrapper v3_1_1">
        <Container>
          <div className="about-grid">
            <div className="overview-container">
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
            <div className="specification-container">
              <ul>
                { productSpecifications.map((item, index) => {
                  return (
                    <li key={(`about${index}`)}><ProductSpec iconName={item.iconName} title={item.title} description={item.description} /></li>
                  );
                })}
              </ul>
            </div>
          </div>
        </Container>
      </Row>
    </Fragment>
  );
}

export function ProductSpec({ iconName, title, description }) {
  return (
    <div className="product-spec-container">
      <div className="icon-container">
        <SvgIcon viewBox={"0 0 40 40"} fontSize={"large"} color="#e6e6e7" iconName={iconName} />
      </div>
      <div className="content-container">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
}

About.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
}

ProductSpec.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
}